import React from "react";
import FilterSolidSVG from "assets/icons/filter-solid.inline.svg";

import Icon from "./Icon";

const FilterIconSolid = ({ ...rest }) => (
  <Icon name="filterSolid" alt="Filter" {...rest}>
    <FilterSolidSVG />
  </Icon>
);

export default FilterIconSolid;
